<template>
    <div v-if="configModal.model">
        <div class="form-group row flex-nowrap">
            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('managerForm.settingPage.titlePage') }} </label>
            <div class="col-sm-11">
                <InputText :model.sync="configModal.title" :config.sync="configEditFormPage.configFieldNamePage" :disabled="true" />
            </div>
        </div>
        <!-- block -->
        <div class="col-sm-12">
            <div v-if="![PAGE_TYPES._I[3]].includes(this.propTypePage)" class="ifame_page overflow-auto">
                <IframComponent
                    class="mx-auto"
                    :typeHandle="`edit`"
                    :typePage="propTypePage"
                    :style="`width:${pixel_action ? `${pixel_action}px` : '100%'}`"
                    :dataForm="dataFormEdit"
                />
            </div>
        </div>
    </div>
</template>

<script>
import IframComponent from '../../../../iframe-page/main.vue';

import { InputText } from '@/components/Input';
import { configEditFormPage } from '../../../../components/setting-page/constants';
import { PAGE_TYPES } from '@/views/pages/phase2/manager-form/constants';

export default {
    name: 'ModalEditPage',
    components: {
        InputText,
        IframComponent
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        },
        configModal: {
            type: Object,
            required: true,
            default: () => null
        }
    },
    data() {
        return {
            configEditFormPage: configEditFormPage(),
            dataFormEdit: this.dataForm,
            pixel_action: '',
            propTypePage: '',
            PAGE_TYPES
        };
    },
    methods: {},
    watch: {
        dataForm: {
            handler(val) {
                this.dataFormEdit = val;
            },
            immediate: true
        },

        'configModal.model': {
            handler(val) {
                if (val) {
                    this.propTypePage = this.configModal?.childPage?.type_page_wl;
                }
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
